/* eslint-disable */
export default {
  lang: {
    zh: '中文',
    en: 'English',
    sp: 'Español'
  },
  nav: {
    home: '首页',
    product: '产品中心',
    news: '新闻中心',
    aboutUs: '关于我们',
    contactUs: '联系我们',
    tips: '支持根据车型或者配件名搜索'
  },
  title: {
    oneDream: '同一个梦想',
    guestDepartment: '客户分布',
    contact: '联系我们',
    contactUs: '联系我们',
    QRCode: '二维码',
    product: '产品',
    pressCenter:'新闻中心',
    companyProfile: '公司简介',
    developmentPath: '公司历程',
    honor: '公司荣誉',
    aboutUs: '了解我们'
  },
  other: {
    keyWords: '关键词',
    search: '搜索',
    readMore: '查看更多',
    noMore: '没有更多了',
    selectProduct: '选择产品分类',
    choose: '选择分类',
    prompt: '提示',
    contactService: `通过邮箱sales@dertparts.com联系我们获取电子目录`
  },
  product: {
    classify: '筛选',
    noDataText: '暂无数据'
  }
}